"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DATA_ORIENT: function() {
        return DATA_ORIENT;
    },
    indexToRotation: function() {
        return indexToRotation;
    },
    rotationToIndex: function() {
        return rotationToIndex;
    }
});
const DATA_ORIENT = Object.freeze({
    DATA_ORIENT_NO_CHANGE: 0,
    DATA_ORIENT_ROTATE_90CW: 1,
    DATA_ORIENT_ROTATE_90CCW: 2,
    DATA_ORIENT_ROTATE_180: 3,
    DATA_ORIENT_FLIP_VERT_ROTATE_90CW: 4,
    DATA_ORIENT_FLIP_VERT_ROTATE_90CCW: 5,
    DATA_ORIENT_FLIP_VERT_ROTATE_180: 6,
    DATA_ORIENT_FLIP_HORZ_ROTATE_90CW: 7,
    DATA_ORIENT_FLIP_HORZ_ROTATE_90CCW: 8,
    DATA_ORIENT_FLIP_HORZ_ROTATE_180: 9
});
function indexToRotation(index) {
    const rotationIndices = [
        0,
        90,
        270,
        180
    ];
    if (index >= 0 && index < rotationIndices.length) {
        return rotationIndices[index];
    } else {
        return 0;
    }
}
function rotationToIndex(degree) {
    const normalDeg = (360 + degree) % 360;
    const rotationKeys = {
        0: DATA_ORIENT.DATA_ORIENT_NO_CHANGE,
        90: DATA_ORIENT.DATA_ORIENT_ROTATE_90CW,
        180: DATA_ORIENT.DATA_ORIENT_ROTATE_180,
        270: DATA_ORIENT.DATA_ORIENT_ROTATE_90CCW,
        default: DATA_ORIENT.DATA_ORIENT_NO_CHANGE
    };
    return rotationKeys[normalDeg] || DATA_ORIENT.DATA_ORIENT_NO_CHANGE;
} // const orientation = {
 //   indexToRotation,
 //   rotationToIndex,
 // };
 // export default orientation;
